<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
  [title]="titlePage"
  start="{{startStage}}"
  end="{{endStage}}"
></app-ion-common-header>

<ion-content
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <app-ion-common-label
    class="document-type-label1"
    labelStyle="display-rg"
    labelDescription="Qual é o nome da rua?"
  >
  </app-ion-common-label>

  <div class="conent-center conent-center--mrt-lg">
    <form [formGroup]="addressNameForm" (ngSubmit)="submitForm($event)">
      <app-ion-common-input
        [fieldValue]="name"
        [placeholder]="placeholder"
        [error]="error"
        [id]="idComponentName"
        [textError]="textError"
        maxLength="150"
        (textChange)="name=$event; errorMessage();"
        type="text"
        [idLabel]="idLabel"
        [label]="label"
        [replaceStrTo]="'documentWithSpace'"
        [disabled]="!this.edit"
        name="nameAddress"
        formControlName="nameAddress"
        ngDefaultControl
      >
      </app-ion-common-input>
    </form>
  </div>

  <app-ion-common-button
    class="hidden"
    [ngClass]="{'hidden': !buttonEnable || name?.length === 0}"
    [attr.aria-hidden]="!buttonEnable"
    label="Continuar"
    (clickButton)="clickNext();"
  ></app-ion-common-button>
</ion-content>
